import(/* webpackMode: "eager" */ "/app/nextjs/src/app/layout.tsx");
